<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Sales Commission Payout"
            />
        </div>
        <div class="mt-2 px-2">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
              <div class="mb-1">
                <label for="colFormLabel" class="col-form-label">Month</label>
                <vField
                    v-model="month"
                    name="month"
                    id="month"
                    type="month"
                    class="form-control"
                />
              </div>
            </div>
          <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
            <div class="mb-1">
              <label for="colFormLabel" class="col-form-label">Staff Id</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="number"
                  placeholder="Enter Staff Id"
                  v-model="staffId"
              >
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1 mt-2">
            <button
                style="min-width: 64px;"
                @click="onClickToGo"
                class="btn btn-primary btn-block waves-effect waves-float waves-light"
            > Go
            </button>
          </div>
        </div>
        </div>
      <div class="col-12">
        <div class="d-flex justify-content-end px-2">
          <button
              @click="onClickToPrint"
              class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect mx-1"
          >
            Print
          </button>
        </div>
      </div>

        <div class="col-12">
          <div class="card p-2" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th class="text-center">Staff ID</th>
                  <th class="text-center">Staff Name</th>
                  <th class="text-center">Designation</th>
                  <th class="text-center">Ref ID</th>
                  <th class="text-right">Personal Sales Commission</th>
                  <th class="text-right">Group Sales Commission</th>
                  <th class="text-center">Company Sales Share</th>
                  <th class="text-right">BP Commission</th>
                  <th class="text-right">Total Commission</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in tableItems" :key="i">
                  <td>{{ item.serial_no }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.level_name }}({{ item.equivalent_designation }})</td>
                  <td>{{ item.parent_serial_no }}</td>
                  <td class="text-right">{{ commaFormat(item.personal_sale_amount) }}</td>
                  <td class="text-right">{{ commaFormat(item.group_sale_commission) }}</td>
                  <td class="text-right">{{ commaFormat(item.company_sale_share) }}</td>
                  <td class="text-right">{{ commaFormat(item.group_bp_commission) }}</td>
                  <td class="text-right">{{ commaFormat(item.total_sale_commission) }}</td>
                </tr>
                 <tr v-if="tableItems.length < 1">
                   <td colspan="9" class="text-center">No Data found</td>
                 </tr>
                </tbody>
              </table>

              <div class="px-2 pt-2">
                <Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/>
              </div>
            </div>
          </div>
        </div>

        <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleSdm from "@/services/modules/sdm/sdm";
import { computed } from 'vue';
import handleCompany from "@/services/modules/company";
import saleCommissionPayoutPdf from '@/services/utils/pdf/saleCommissionPayoutPdf';
import figureFormatter from "@/services/utils/figureFormatter";
import Pagination from '@/components/atom/Pagination'

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const staffId = ref(null);
const month = ref(null);
const { fetchCompanyInfo } = handleCompany();
let companyInfo = reactive({})
const { exportToPDF } = saleCommissionPayoutPdf();
const token = computed(() => localStorage.getItem('token'));
const { commaFormat } = figureFormatter();

const {
  fetchSaleCommissionPayoutData
} = handleSdm()
let offset = ref(20)

const onClickToGo = () => {
  getSaleCommissionData();
}

async function onClickToPrint() {
  let query = getQuery();
  query += `&is_all=1`;

  await fetchSaleCommissionPayoutData(query).then((res) => {
    if (! res.status) {
      showError(res.message)
      return
    }
    tableItems.value = res.data;
  }).then(() => {
    exportToPDF(companyInfo, tableItems.value, month.value)
  }).catch((err) => {
    console.log("Something went wrong");
  });
}

function setPagination(data) {
  if(!data.data.length) return
  store.commit('setPaginationData', {
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getSaleCommissionData();
}

const getSaleCommissionData = async () => {
    const query = getQuery();
  console.log(query)
    loading.value = true
    tableItems.value = []

    await fetchSaleCommissionPayoutData(query).then(res => {
        if (!res.status){
            showError(res.message)
            return
        }
        tableItems.value = res.data.data;

        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const setCompanyInfo = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo = res.data;
  }).catch((error) => {
    console.log(error);
  });
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (staffId.value) query += '&staff_id=' + staffId.value;
    if (month.value) query += '&month=' + month.value;
    if (route.query.page) query += '&page=' + route.query.page;
    query += '&offset='+offset.value
    return query;
}

onMounted(() => {
  setCompanyInfo()
});

</script>

<style scoped>
.head td {
  text-align: right;
}
</style>